import { Dialog } from "@base-ui/react/dialog";
import { Trash2 } from "lucide-react";
import { Button } from "./ui/Button";

export function ClearPadDialog({ onClear }: { onClear: () => Promise<void> }) {
  return (
    <Dialog.Root>
      <Dialog.Trigger render={<Button variant="danger" title="Clear Slip" />}>
        <Trash2 size={18} />
        <span className="hidden sm:inline">Clear</span>
      </Dialog.Trigger>
      <Dialog.Portal>
        <Dialog.Backdrop className="fixed inset-0 z-40 bg-black/25 backdrop-blur-[2px]" />
        <Dialog.Popup className="fixed left-1/2 top-1/2 z-50 w-[calc(100vw-2rem)] max-w-sm -translate-x-1/2 -translate-y-1/2 rounded-lg border border-neutral-200 bg-white p-5 shadow-[0_24px_80px_rgba(0,0,0,0.22)] outline-none">
          <Dialog.Title className="text-lg font-semibold text-neutral-950">Clear this Slip?</Dialog.Title>
          <Dialog.Description className="mt-2 text-sm leading-6 text-neutral-600">
            This removes the shared text and all files from this link.
          </Dialog.Description>
          <div className="mt-5 flex justify-end gap-2">
            <Dialog.Close render={<Button variant="secondary" />}>Cancel</Dialog.Close>
            <Dialog.Close render={<Button variant="danger" onClick={() => void onClear()} />}>
              Clear Slip
            </Dialog.Close>
          </div>
        </Dialog.Popup>
      </Dialog.Portal>
    </Dialog.Root>
  );
}
